<template>
    <nav class="flex items-center gap-1" aria-label="Pagination">
        <button
            type="button"
            class="flex items-center justify-center w-8 h-8 rounded border border-theme-border text-theme-base transition-colors hover:bg-theme-hover disabled:opacity-40 disabled:cursor-not-allowed"
            :disabled="value <= 1"
            aria-label="Página anterior"
            @click="goTo(value - 1)"
        >
            <chevron-left-icon class="w-4 h-4" />
        </button>

        <button
            v-for="(page, index) in pages"
            :key="page === '...' ? 'dots-' + index : page"
            type="button"
            :disabled="page === '...'"
            :class="[
                'flex items-center justify-center w-8 h-8 rounded text-sm font-medium transition-colors',
                page === '...'
                    ? 'cursor-default text-theme-muted'
                    : page === value
                    ? 'bg-theme-primary text-theme-inverse'
                    : 'border border-theme-border text-theme-base hover:bg-theme-hover'
            ]"
            @click="goTo(page)"
        >
            {{ page === "..." ? "…" : page }}
        </button>

        <button
            type="button"
            class="flex items-center justify-center w-8 h-8 rounded border border-theme-border text-theme-base transition-colors hover:bg-theme-hover disabled:opacity-40 disabled:cursor-not-allowed"
            :disabled="value >= length"
            aria-label="Página siguiente"
            @click="goTo(value + 1)"
        >
            <chevron-right-icon class="w-4 h-4" />
        </button>
    </nav>
</template>

<script>
import ChevronLeftIcon from "@/components/icons/ChevronLeftIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";

export default {
    name: "CustomPagination",
    components: { ChevronLeftIcon, ChevronRightIcon },
    props: {
        value: { type: Number, default: 1 },
        length: { type: Number, default: 0 }
    },
    computed: {
        pages() {
            const delta = 1;
            const range = [];
            const rangeWithDots = [];
            let last;

            for (let i = 1; i <= this.length; i++) {
                if (
                    i === 1 ||
                    i === this.length ||
                    (i >= this.value - delta && i <= this.value + delta)
                ) {
                    range.push(i);
                }
            }

            range.forEach((i) => {
                if (last) {
                    if (i - last === 2) {
                        rangeWithDots.push(last + 1);
                    } else if (i - last !== 1) {
                        rangeWithDots.push("...");
                    }
                }
                rangeWithDots.push(i);
                last = i;
            });

            return rangeWithDots;
        }
    },
    methods: {
        goTo(page) {
            if (
                typeof page !== "number" ||
                page < 1 ||
                page > this.length ||
                page === this.value
            ) {
                return;
            }
            this.$emit("input", page);
        }
    }
};
</script>
